import { Button } from "~/react/ui/button"
import { Icon } from "~/react/ui/icon"
import type { DiscoverPaths } from "~/react/types/discover"
import emptyStateImageUrl from "~/images/empty_states/leads.svg"

const t = (key: string, options?: Record<string, unknown>) => window.i18n.t(key, options)

export function NoResults() {
  return (
    <div className="board-box">
      <div className="empty-state">
        <div className="empty-state__img">
          <img src={emptyStateImageUrl} alt="" />
        </div>
        <div className="empty-state__content">
          <h2 className="empty-state__title">
            {t("js.discover.index.no_matches.title")}
          </h2>
          <p
            dangerouslySetInnerHTML={{
              __html: t("js.discover.index.no_matches.description_html"),
            }}
          />
        </div>
      </div>
    </div>
  )
}

interface UpgradePromptProps {
  remainingCount: number
  paths: DiscoverPaths
}

export function UpgradePrompt({ remainingCount, paths }: UpgradePromptProps) {
  return (
    <div className="upgrade-prompt">
      <div className="upgrade-prompt__content">
        <h3 className="upgrade-prompt__title">
          {t("js.discover.index.upgrade_more_results.title", {
            count: remainingCount,
            number: remainingCount,
          })}
        </h3>
        <p className="upgrade-prompt__description">
          {t("js.discover.index.upgrade_more_results.description")}
        </p>
        <Button asChild variant="primary" size="sm">
          <a href={paths.upgradeWelcome} data-turbo-frame="_top">
            <Icon icon="arrow-alt-circle-up" className="mr-2" />
            {t("js.discover.index.upgrade_your_plan")}
          </a>
        </Button>
      </div>
    </div>
  )
}

export function LoadingState() {
  return (
    <div className="board-box pb-0">
      <div className="sidepanel__loader">
        <span className="h-loader" aria-label={t("js.loading")} />
      </div>
    </div>
  )
}
